import { StatusTone } from '../builder/primitives';

/**
 * Map any campaign status string (delivery / enrollment / step / target / action-item) to a
 * `StatusPill` tone. Shared by every drill-down row so a status colour is consistent across levels.
 */
export function toneForStatus(status?: string): StatusTone {
  switch (status) {
    case 'completed':
    case 'complete':
    case 'done':
      return 'done';
    case 'in_progress':
      return 'progress';
    case 'scheduled':
      return 'warn';
    case 'cancelled':
    case 'dropped':
      return 'danger';
    default:
      return 'idle';
  }
}
